import React, { Component } from 'react';
import './Feed.less';

import Post from '../Post/Post.js';

import _ from 'lodash';

class Feed extends Component {
    state = {
        isLoading: true,
        posts: [],
    };

    async componentDidMount() {
        var posts = await this.getPosts();

        if (posts.length === 0) {
            this.setState({
                isLoading: false,
                posts: []
            });
        }

        var searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has("post")) {
            var postName = searchParams.get("post");
            this.loadByPostName(posts, postName);
        }
        else {
            this.loadAllPosts(posts);
        }
    }

    loadByPostName(posts, name) {
        var lowerName = name.toLowerCase();
        var post = _.find(posts, p => p.name.toLowerCase() === lowerName);

        if (post === null || post === undefined) {
            this.setState({
                isLoading: false,
                posts: []
            });
        }

        this.setState({
            isLoading: false,
            posts: [ post ]
        });
    }

    loadAllPosts(posts) {
        var sorted = _.orderBy(posts, ['date'], ['desc']);

        this.setState({
            isLoading: false,
            posts: sorted
        });
    }

    async getPosts() {
        try {
            let response = await fetch('/posts/manifest.json');
            let data = await response.json();

            return data.published;
        }
        catch (error) {
            console.log(error);
            return [];
        }
    }

    createPosts() {
        var posts = [];

        var postCount = Math.min(this.state.posts.length, 10);
        var maximize = this.state.posts.length === 1;

        for (let p = 0; p < postCount; p++) {
            var post = this.state.posts[p];

            var component = <Post name={post.name}
                                  url={post.url}
                                  title={post.title}
                                  date={post.date}
                                  maximize={maximize}
                                  key={p}>
                            </Post>;

            posts.push(component);
        }

        return posts;
    }

    render() {
        const { isLoading } = this.state;

        return (
            <div className="feed">
                { isLoading ? "Loading..." : this.createPosts() }
            </div>
        );
    }
}

export default Feed;



// WEBPACK FOOTER //
// ./src/Feed/Feed.js